<form [formGroup]="majorCodeForm" (ngSubmit)="onSubmit()" autocomplete="off">
  <div class="row">
    <div class="col-md-6 mb-3">
      <generic-dropdown
        [items]="jobTypeDropdownItems()"
        [label]="'Job Type'"
        [placeholder]="'Select Job Type'"
        [required]="true"
        [allowSearch]="true"
        formControlName="jobTypeId"
        [errormessage]="'Job Type is required'"
      ></generic-dropdown>
    </div>
    <div class="col-md-6 mb-3">
      <input-field
        [label]="'Code'"
        [placeholder]="'Enter code'"
        [required]="true"
        [requiredLabel]="true"
        [errormessage]="'Code is required'"
        formControlName="code"
      ></input-field>
    </div>
    <div class="col-md-12 mb-3">
      <input-field
        [label]="'Description'"
        [placeholder]="'Enter description'"
        [required]="true"
        [requiredLabel]="true"
        [errormessage]="'Description is required'"
        formControlName="description"
      ></input-field>
    </div>
    <div class="col-md-6 mb-3">
      <generic-dropdown
        [items]="typeDropdownItemsFiltered()"
        [label]="'Type'"
        [placeholder]="'Select Type'"
        [required]="true"
        formControlName="type"
        [errormessage]="'Type is required'"
      ></generic-dropdown>
    </div>
    <div class="col-md-6 mb-3">
      <generic-dropdown
        [items]="headerMajorCodeOptions()"
        [label]="'Header Major Code'"
        [placeholder]="'Select Header Major Code'"
        [disabled]="isHeaderSelected()"
        formControlName="headerMajorCodeId"
      ></generic-dropdown>
    </div>
    <div class="col-md-6 mb-3">
      <generic-dropdown
        [items]="uofmList()"
        [label]="'Unit of Measure'"
        [placeholder]="'Select Unit of Measure'"
        [disabled]="isHeaderSelected()"
        formControlName="unitOfMeasureId"
      ></generic-dropdown>
    </div>
    <div class="col-md-6">
      <div class="rounded-3 px-2 py-1 d-flex align-items-center mt-4 pt-2">
        <h6 class="mb-0 fs-14">Production Required</h6>
        <div class="d-flex align-items-center ms-2 d-flex align-items-center">
          <p-toggleswitch class="d-flex align-self-center" formControlName="productionRequired" />
        </div>
      </div>
    </div>
  </div>
</form>
